import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  DtpNoContent,
  DtpContentContainer,
} from 'dtp-react-components';
import {
  Button,
  DataGrid,
  Table,
} from '../../../components/index';
import {
  trataMensagensErro,
  trataMensagemSucesso,
  requestAbrangenciasEntidadeParticipanteRPPS,
  validateObject,
  doPut,
} from '../../../utils/requests';
import { manterApenasFiltro, formatarCnpj } from '../../../utils/helpers';
import { getObject, situacaoOrgaoVinculado } from '../../../utils/listsSelect';
import OrgaoVinculado from '../../cadastros/EntesFederativos/Rpps/OrgaoVinculado';
import ProtectedItem from '../../../components/ComponentesAutenticacao/ProtectedItem';

class CadastroOrgaosVinculados extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }
  getInitialState = () => ({
    orgaoVinculado: {
      cnpj: null,
      idParticipante: null,
      nomeOrgaoVinculado: null,
      situacao: null,
    },
    cnpj: null,
    touched: false,
    validadeCampos: {
      cnpj: false,
      nomeOrgaoVinculado: false,
      situacao: true,
    },
    abrangenciasEntidadeParticipanteRPPS: [],
    showNoContent: false,
    noContentPrimaryMessage: 'Regime Próprio não encontrado para o cnpj informado.',
    noContentSecondaryMessage: 'Informe um protocolo válido.',
  });

  componentDidMount() {
    manterApenasFiltro('');
    this.montaFormulario();
  }

  handleErrorBusca = (error) => {
    let mensagemPrimaria = 'Não foi possível consultar o regime próprio.';
    let mensagemSecundaria = 'Contate o administrador do sistema.';
    if (error) {
      if (error.status) {
        if (error.status === 404) {
          mensagemPrimaria = 'Ente  Federativo não encontrado para o filtro informado.';
          mensagemSecundaria = 'Informe um filtro válido.';
        }
      }
    }
    this.setState({
      showNoContent: true,
      noContentPrimaryMessage: mensagemPrimaria,
      noContentSecondaryMessage: mensagemSecundaria,
    });
  };

  formularioProntoParaEnvio = () => (
    validateObject(this.state.validadeCampos)
  );

  buscarAbrangenciasEntidadeParticipanteRPPS = () => {
    requestAbrangenciasEntidadeParticipanteRPPS(this.handleErrorBusca, '99999');
  }

  montaFormulario = () => {
    this.setState(this.buscarAbrangenciasEntidadeParticipanteRPPS());
  }

  handleModal = () => {
    this.setState({ showModal: !this.state.showModal, acaoModal: this.state.acaoModal });
  }

  createCustomInsertButton = orgao => (
    <React.Fragment>
      {(this.props.auth.checkPermission(['analisar-negocio-sprev'])) ?
        <Button
          hint="Adicionar Orgão Vinculado"
          icon="ico-user-plus"
          onClick={() => this.incluirOrgaoVinculado(orgao)}
        />
      : ''}
    </React.Fragment>
  );

  createActionColumn = (indice, orgao) => (
    <React.Fragment>
      {(this.props.auth.checkPermission(['analisar-negocio-sprev'])) ?
        <Button
          hint="Editar Orgão Vinculado"
          icon="ico-pencil"
          mini
          onClick={() => this.editOrgaoVinculado(indice, orgao)}
        />
      : ''}
    </React.Fragment>
  );

  addSituacaoLabel = (situacaoSelecionado) => {
    const obj = getObject(situacaoOrgaoVinculado, situacaoSelecionado);
    let valorlabel = null;
    if (obj) {
      valorlabel = obj.label;
    }
    return valorlabel;
    // const obj = getObject(situacao, situacaoSelecionado);
    // return obj.label;
  }

  /**
   * Determina quais colunas devem ser exibidas na tabela de dependentes
   */
  montaOrgaoVinculadoTableHeader = () => {
    const tableHeader = [{
      id: 'cnpj',
      label: 'CNPJ',
    }, {
      id: 'nomeOrgaoVinculado',
      label: 'Orgão',
    }, {
      id: 'situacao',
      label: 'Situação',
      dataFormat: this.addSituacaoLabel,
    }];
    if (this.props.auth.checkPermission(['analisar-negocio-sprev'])) {
      tableHeader.push({
        id: 'acoes',
        label: 'Ações',
        dataFormat: this.createActionColumn,
      });
    }
    return tableHeader;
  }

  options = {
    hideSizePerPage: true,
    insertBtn: this.createCustomInsertButton,
    noDataText: 'Nenhum Orgão foi adicionado à lista',
    sizePerPage: 5,
  };

  /**
   * Adiciona Orgao Vinculado a lista
   * FLAG OPERACAO = 1 - INCLUSAO
   * FLAG OPERACAO = 2 - ALTERACAO
   */
  addOrgaoVinculado = (orgao, edit) => {
    const { abrangenciasEntidadeParticipanteRPPS } = { ...this.props };
    if (edit) {
      const orgaoVinculado = { ...orgao };
      if (orgaoVinculado.situacao === '') {
        orgaoVinculado.situacao = 0;
        orgaoVinculado.flagOperacao = 2;
      } else {
        orgaoVinculado.flagOperacao = 2;
      }
      abrangenciasEntidadeParticipanteRPPS[this.state.cell] = orgaoVinculado;
    } else {
      let orgaoExisteNaLista = false;
      // const cnpjNovoOrgao = orgao.cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      const cnpjNovoOrgao = orgao.cnpj.replace(/(.{2})(.{3})(.{3})(.{4})(.{2})/, '$1.$2.$3/$4-$5');
      abrangenciasEntidadeParticipanteRPPS.forEach((orgaoExistente) => {
        const orgaoAux = orgaoExistente;
        orgaoAux.cnpj = orgaoExistente.cnpj;
        if (orgaoAux.cnpj === cnpjNovoOrgao) {
          trataMensagensErro(['O orgão já foi cadastrado anteriormente.']);
          orgaoExisteNaLista = true;
        }
      });
      if (orgaoExisteNaLista === false) {
        const orgaoInclusao = orgao;
        orgaoInclusao.flagOperacao = 1;
        // orgaoInclusao.idParticipante = null;
        abrangenciasEntidadeParticipanteRPPS.unshift(orgaoInclusao);
      }
    }
    this.alteraListaOrgaosVinculados(abrangenciasEntidadeParticipanteRPPS, null);
  }

  /**
   * Altera um orgao da lista
   */
  editOrgaoVinculado = (indice, orgaoVinculadoSelecionado) => {
    let errosOrgaoVinculadoSelecionado = null;
    if (this.errosOrgaoVinculado) {
      errosOrgaoVinculadoSelecionado = this.errosOrgaoVinculado
        .filter(erro => erro.indiceLista === indice);
    }
    this.setState({
      cell: indice,
      acaoModal: 'edicao',
      orgaoVinculadoSelecionado,
      errosOrgaoVinculadoSelecionado,
    }, this.handleModal);
  }

  /**
   * inclui um orgao da lista
   */
  incluirOrgaoVinculado = () => {
    this.setState({
      acaoModal: 'criacao',
    }, this.handleModal);
  }

  validacaoErrosOrgaoVinculado = (errosOrgaoVinculado) => {
    let camposInvalidos = null;
    // if (isDelete) {
    //   camposInvalidos = errosOrgaoVinculado;
    // } else {
    camposInvalidos =
      this.state.camposOrgaosVinculadosInvalidos.filter(erro =>
        (errosOrgaoVinculado.includes(erro) ? null : erro));
    // }
    this.setState({ camposOrgaosVinculadosInvalidos: camposInvalidos });
  }

  handleChange = (changeObj, name, callback = null) => {
    const { orgaoVinculado } = { ...this.state };
    this.setState({
      orgaoVinculado: {
        ...orgaoVinculado,
        [name]: changeObj.value,
      },
      validadeCampos: {
        ...this.state.validadeCampos,
        [name]: changeObj.isValid,
      },
    }, callback);
  }

  montaValidadeCampos = (periodo) => {
    const { validadeCampos } = { ...this.state };
    Object.keys(periodo).forEach((key) => {
      validadeCampos[key] = true;
    });
    return validadeCampos;
  }

  handleChangeOrgaosVinculados = (changeObj, name) => {
    const { orgaoVinculado } = { ...this.state };
    const validadeCampos = this.montaValidadeCampos(orgaoVinculado);
    this.setState({
      orgaoVinculado: {
        ...orgaoVinculado,
        [name]: changeObj,
      },
      validadeCampos: {
        ...validadeCampos,
      },
    });
  }

  alteraListaOrgaosVinculados = (listaOrgaosVinculados, errosOrgaosVinculados) => {
    if (errosOrgaosVinculados) {
      this.validacaoErrosOrgaoVinculado(errosOrgaosVinculados, true);
    }
    this.handleChangeOrgaosVinculados(listaOrgaosVinculados, 'abrangenciasEntidadeParticipanteRPPS');
  }

  /**
   * Remove a selecao do dependente
   */
  resetOrgaoVinculadoSelecionado = () => {
    this.setState({
      orgaoVinculadoSelecionado: null,
      acaoModal: null,
      errosOrgaoVinculadoSelecionado: null,
    });
  }

  /**
  * Trata o click do botao de submissao do formulario
  * Se analise estiver indeferindo, exibir alerta de confirmacao
  */
  handleSaveButton = () => {
    this.confirmSendData();
  }
  /**
  * Trata envio dos dados
  */
  confirmSendData = () => {
    const touched = true;
    const url = 'abrangencia-entidade-participante';

    const { validadeCampos } = { ...this.state };
    Object.keys(validadeCampos).forEach((key) => {
      validadeCampos[key] = true;
    });

    this.setState({
      touched,
      validadeCampos,
      requestPesquisa: null,
    }, () => this.handleSave(url));
  }

  handleSave = (url) => {
    if (this.formularioProntoParaEnvio()) {
      // let { periodosVigencia } = { ...this.state };
      let listaOrgaos = this.props.abrangenciasEntidadeParticipanteRPPS;

      if (listaOrgaos &&
        listaOrgaos.length > 0) {
        const colecao = [];
        listaOrgaos.forEach((periodo) => {
          if (periodo.flagOperacao) {
            colecao.push(periodo);
          }
        });
        if (colecao.length > 0) {
          listaOrgaos = colecao;
        } else {
          // não alterou e nem incluiu orgao vinculado
          const listaAux = [];
          listaOrgaos.map((item, i) => {
            const itemIndexado = item;
            itemIndexado.contador = i;

            if (i <= 5) {
              listaAux.push(itemIndexado);
            }
            return listaAux;
          });
          listaOrgaos = [];
          listaOrgaos = listaAux;
        }
      }
      doPut(
        url,
        { orgaosVinculados: listaOrgaos },
        this.trataSucesso,
      );
      // doPut(
      //   url,
      //   regimeProprio,
      //   this.trataSucessoResponseEnvio,
      //   this.trataErrosResponse,
      //   options,
      // );
    } else {
      trataMensagensErro(['Informe corretamente os atributos indicados na tela.']);
    }
  }

  trataSucesso = () => {
    const mensagemSucesso = 'Orgão Vinculado atualizado.';
    // this.props.history.goBack();
    this.montaFormulario();
    this.setState({
      estadoFormulario: 'criado',
    });
    trataMensagemSucesso([mensagemSucesso]);
  }

  /**
   * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
   */
  trataSucessoResponseEnvio = () => {
    if (this.state.chaveConfirmacao) {
      this.setState({
        chaveConfirmacao: null,
        alertas: [],
        showModalAlerta: !this.state.showModalAlerta,
      }, this.trataSucesso);
    } else {
      this.trataSucesso();
    }
  }

  render() {
    if (this.state.showNoContent) {
      return (
        <DtpNoContent
          primaryText={this.state.noContentPrimaryMessage}
          secondaryText={this.state.noContentSecondaryMessage}
          show={this.state.showNoContent}
        />);
    }
    const listaOrgaosVinculadosIndexada =
      this.props.abrangenciasEntidadeParticipanteRPPS.map((item, i) => {
        const itemIndexado = item;
        itemIndexado.acoes = i;
        // itemIndexado.cnpj = itemIndexado.cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        itemIndexado.cnpj = formatarCnpj(itemIndexado.cnpj);
        return itemIndexado;
      });

    const modalOrgaoVinculado = this.state.showModal ?
      (<OrgaoVinculado
        acaoModal={this.state.acaoModal}
        acao={this.props.acao}
        addOrgaoVinculado={this.addOrgaoVinculado}
        orgaoVinculado={this.state.orgaoVinculadoSelecionado}
        errosOrgaoVinculado={this.state.errosOrgaoVinculadoSelecionado}
        validacaoErrosOrgaoVinculado={this.validacaoErrosOrgaoVinculado}
        onHide={this.handleModal}
        resetOrgaoVinculado={this.resetOrgaoVinculadoSelecionado}
        showModal
      />
      ) : null;

    let botaoAcaoPrincipal;
    const configBotaoPrincipal = {
      onClick: this.handleSaveButton,
    };

    configBotaoPrincipal.permissoes = ['analisar-negocio-sprev'];
    configBotaoPrincipal.titulo = 'Salvar';
    configBotaoPrincipal.hint = 'Salvar Período';
    const botaoAcaoVoltar = (
      <Button
        className="left"
        onClick={this.props.history.goBack}
        title="Voltar"
        hint="Voltar para tela anterior"
      />
    );

    if (configBotaoPrincipal.titulo) {
      botaoAcaoPrincipal = (
        <ProtectedItem allowedPermissions={configBotaoPrincipal.permissoes}>
          <Button
            className="dtp-primary right"
            disabled={!this.formularioProntoParaEnvio()}
            title={configBotaoPrincipal.titulo}
            onClick={configBotaoPrincipal.onClick}
            hint={configBotaoPrincipal.hint}
          />
        </ProtectedItem>
      );
    }

    return (
      <DtpContentContainer>
        <DataGrid title="Dados dos Orgãos Vinculados" icon="ico-users" >
          <Table
            bordered
            data={listaOrgaosVinculadosIndexada}
            insertRow="true"
            options={this.options}
            listaTableHeader={this.montaOrgaoVinculadoTableHeader()}
            pagination
            fetchInfo={this.fetchInfo}
          />
          {modalOrgaoVinculado}
        </DataGrid>
        <div className="row">
          { botaoAcaoVoltar }
          { botaoAcaoPrincipal }
        </div>
      </DtpContentContainer>
    );
  }
}

CadastroOrgaosVinculados.propTypes = {
  acao: PropTypes.string.isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.function,
  }).isRequired,
  abrangenciasEntidadeParticipanteRPPS: PropTypes.arrayOf({
    cnpj: PropTypes.string,
    nome: PropTypes.string,
    situacao: PropTypes.number,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      protocolo: PropTypes.string,
      acao: PropTypes.string,
    }),
  }),
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }),
};

CadastroOrgaosVinculados.defaultProps = {
  match: null,
  auth: null,
  abrangenciasEntidadeParticipanteRPPS: [],
};

const mapStateToProps = state => ({
  abrangenciasEntidadeParticipanteRPPS: state.base.abrangenciasEntidadeParticipanteRPPS,
});

export default connect(mapStateToProps)(CadastroOrgaosVinculados);



// WEBPACK FOOTER //
// ./src/pages/cadastros/OrgaosVinculadosUniao/CadastroOrgaosVinculados.jsx